// import { useState } from 'react';
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
//   Navigate,
// } from 'react-router-dom';
// import './App.css';
// import NavBar from './nav-bar.js';
// import FileUploader from './pages/file-attachment/file-attachment.js';
// import Login from './pages/Login/login.component.js';
// import Laboratory from './pages/laboratory/laboratory.component.js';
// import Purchase from './pages/Purchase/purchase.component.js';

// function App() {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [user, setUser] = useState(null);

//   const handleLogin = (username) => {
//     setIsAuthenticated(true);
//     setUser(username);
//   };

//   const handleLogout = () => {
//     setIsAuthenticated(false);
//     setUser(null);
//   };

//   return (
//     <Router>
//       {/* Only show NavBar if the user is authenticated */}
//       {isAuthenticated && (
//         <NavBar
//           isAuthenticated={isAuthenticated}
//           user={user}
//           onLogout={handleLogout}
//         />
//       )}
//       <Routes>
//         {/* Redirect to login if not authenticated */}
//         <Route
//           path='/'
//           element={
//             !isAuthenticated ? (
//               <Login onLogin={handleLogin} />
//             ) : (
//               <>
//                 <Navigate to='/laboratory' />
//                 <Navigate to='/purchase' />
//               </>
//             )
//           }
//         />

//         {/* Protected Route: Laboratory */}
//         <Route
//           path='/laboratory'
//           element={
//             isAuthenticated ? (
//               <main>
//                 <Laboratory />
//               </main>
//             ) : (
//               <Navigate to='/' />
//             )
//           }
//         />
//         <Route
//           path='/purchase'
//           element={
//             isAuthenticated ? (
//               <main>
//                 <Purchase />
//               </main>
//             ) : (
//               <Navigate to='/' />
//             )
//           }
//         />
//       </Routes>
//     </Router>
//   );
// }

// export default App;
import { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import './App.css';
import NavBar from './nav-bar.js';
import Login from './pages/Login/login.component.js';
import Laboratory from './pages/laboratory/laboratory.component.js';
import Purchase from './pages/Purchase/purchase.component.js';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => localStorage.getItem('isAuthenticated') === 'true'
  );
  const [user, setUser] = useState(() => localStorage.getItem('user'));

  useEffect(() => {
    localStorage.setItem('isAuthenticated', isAuthenticated);
    localStorage.setItem('user', user);
  }, [isAuthenticated, user]);

  const handleLogin = (username) => {
    setIsAuthenticated(true);
    setUser(username);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUser(null);
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('user');
  };

  return (
    <Router>
      {isAuthenticated && (
        <NavBar
          isAuthenticated={isAuthenticated}
          user={user}
          onLogout={handleLogout}
        />
      )}
      <Routes>
        <Route
          path='/'
          element={
            !isAuthenticated ? (
              <Login onLogin={handleLogin} />
            ) : (
              <Navigate to='/laboratory' />
            )
          }
        />
        <Route
          path='/laboratory'
          element={isAuthenticated ? <Laboratory /> : <Navigate to='/' />}
        />
      </Routes>
    </Router>
  );
}

export default App;
